import {
  DELIVERY_ZIP_TYPES,
  STORAGE_IDENTIFIERS,
  TIMESPANS,
  WORKFLOWS,
} from "./common/constants";
import { isAPOFPOZipCode } from "./common/utils";
import { getConfig } from "./config/localizerConfig";
import HttpError from "./error/HttpError";
import cookie from "./storageManager/methods/cookie";
import http from "./storageManager/methods/http";

export const getDeliveryZipCookie = () => {
  return cookie.get(STORAGE_IDENTIFIERS.DELIVERY_ZIP);
}

export const getDeliveryZipTypeCookie = () => {
  return cookie.get(STORAGE_IDENTIFIERS.DELIVERY_ZIP_TYPE);
}

export const determineZipcodeType = (workflow) => {

  if ([DELIVERY_ZIP_TYPES.USER, DELIVERY_ZIP_TYPES.LOGIN].includes(getDeliveryZipTypeCookie())) {
    return getDeliveryZipTypeCookie();
  }

  if ([WORKFLOWS.DEFAULT, WORKFLOWS.LOCALIZED_BY_DEFAULT].includes(workflow)) {
    return DELIVERY_ZIP_TYPES.DEFAULT;
  }
  return DELIVERY_ZIP_TYPES.AUTO;
};

const localConfig = getConfig();

const deliveryZipcodeService = {
  getDeliveryZipcodeDetails() {
    const zipcode = getDeliveryZipCookie();
    const { shownDefault, type } = this.getDeliveryZipcodeType() || {};
    if (type) {
      return { shownDefault, type, zipcode };
    }
    return { zipcode };
  },
  getDeliveryZipcodeType() {
    try {
      const type = cookie.get(STORAGE_IDENTIFIERS.DELIVERY_ZIP_TYPE);
      if (type) {
        return {
          shownDefault: type !== DELIVERY_ZIP_TYPES.DEFAULT,
          type,
        };
      }
    } catch (e) {
      console.error(e);
    }
  },
  updateDeliveryZipcodeDetails(deliveryZipcode, type) {
    try {
      if (deliveryZipcode) {
        cookie.put({
          key: STORAGE_IDENTIFIERS.DELIVERY_ZIP,
          value: deliveryZipcode.toString().trim(),
          expireTime: TIMESPANS.ONE_YEAR,
        });
      }
      if (type) {
        const typeFromStorage = cookie.get(
          STORAGE_IDENTIFIERS.DELIVERY_ZIP_TYPE
        );
        
        if (typeFromStorage !== DELIVERY_ZIP_TYPES.USER) {
          cookie.put({
            key: STORAGE_IDENTIFIERS.DELIVERY_ZIP_TYPE,
            value: type,
            expireTime: TIMESPANS.ONE_YEAR,
          });
        }
      }
    } catch (e) {
      console.error(e);
    }
  },
  updateDeliveryZipcodeFromLocalizerResponse(localizerResponse) {
    try {
      const workflow = localizerResponse?.status?.getWorkflow();
      const zipcodeType = determineZipcodeType(workflow);
      if (!getDeliveryZipCookie()) {
        const localStoreZip = localizerResponse.getLocalizedStore().zipcode;
        if (localStoreZip) {
          this.updateDeliveryZipcodeDetails(localStoreZip, zipcodeType);
        }
      } else if (!getDeliveryZipTypeCookie()) {
        this.updateDeliveryZipcodeDetails(getDeliveryZipCookie(), zipcodeType);
      }
    } catch (e) {
      console.error(e);
    }
  },
  updateDeliveryZipcodeOnLocalizationWorkflow(localStore, workflow) {
    try {
      const { type } = this.getDeliveryZipcodeType() || {};
      const postalCode = localStore?.address?.postalCode;

      // Handle USER type
      if (type === DELIVERY_ZIP_TYPES.USER) {
        if (!getDeliveryZipCookie() && postalCode) {
          this.updateDeliveryZipcodeDetails(postalCode, type);
        }
        return;
      }

      // If the user is logged in, return early
      if (type === DELIVERY_ZIP_TYPES.LOGIN) {
        return;
      }

      // Handle DEFAULT or AUTO types
      const zipcodeType = determineZipcodeType(workflow);
      this.updateDeliveryZipcodeDetails(postalCode, zipcodeType);

    } catch (e) {
      console.error(e);
    }
  },
  async validateUSZipcode(
    zipcode,
    successCallback,
    failureCallback,
    errorCallback
  ) {
    try {
      const locationURL = `${localConfig.host}/StoreSearchServices/v2/location?zipcode=${zipcode}&type=json`;
      const result = await http.get(locationURL);
      if (result?.locations?.length > 0) {
        if (successCallback) {
          successCallback(result);
        }
      } else {
        if (failureCallback) {
          failureCallback(result);
        }
      }
    } catch (e) {
      if (failureCallback && e instanceof HttpError) {
        failureCallback(e);
      } else if (errorCallback) {
        errorCallback(e);
      }
    }
  },
  isAPOFPOZipCode() {
    const zipcode = getDeliveryZipCookie();

    return isAPOFPOZipCode(zipcode);
  }
};

export default deliveryZipcodeService;
